import { createContext, useState } from 'react';

import ClubStaffData from './ClubStaffData';

export const ClubStaffContext = createContext();

const ClubStaffContextProvider = ({ children }) => {
  const stateHook = useState(ClubStaffData.INITIAL_CLUB_STAFF_STATE);

  return (
    <ClubStaffContext.Provider value={stateHook}>
      {children}
    </ClubStaffContext.Provider>
  );
};

export default ClubStaffContextProvider;